import React, { useEffect, useRef, useState } from 'react'

import { Typography, Accordion } from '@telavita-core/react-design-kit'

import ModalGeneric from '../ModalGeneric'

import { Container, Item, PsiqTabWrapper } from './styles'
import { useIntersectionObserver } from 'hooks'
import Tabs from 'components/Tabs'

import { ReactComponent as UnderConstruction } from 'static/svg/under-construction.svg'

export interface Question {
  id?: number
  title: string
  reducedTitle?: string
  text: string | JSX.Element
}
interface HelpModalProps {
  onClose: () => void
  questions: Question[]
  title: string
  activeQuestion?: number
  showTabs?: boolean
  defaultTab?: 'PSIC' | 'PSIQ'
  tabs?: Array<{
    title: string
    code: 'PSIC' | 'PSIQ'
  }>
}

export function HelpModal({
  onClose,
  questions,
  title,
  activeQuestion = null,
  showTabs = false,
  tabs,
  defaultTab = 'PSIC'
}: HelpModalProps): JSX.Element {
  const [shouldFocusQuestion, setShouldFocusQuestion] = useState(false)
  const [selectedTab, setSelectedTab] = useState(defaultTab)

  const activeQuestionRef = useRef<HTMLLIElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const { observerElement } = useIntersectionObserver(activeQuestionRef.current)

  useEffect(() => {
    if (activeQuestion) {
      setShouldFocusQuestion(true)
    }
  }, [activeQuestion])

  useEffect(() => {
    if (shouldFocusQuestion && observerElement) {
      const marginValue = 70

      const elementInScrollable = activeQuestionRef.current
      const positionFromTopOfScrollable = elementInScrollable.offsetTop

      const scrollableParentElement = containerRef.current
      scrollableParentElement.scrollTop = positionFromTopOfScrollable - marginValue

      setShouldFocusQuestion(false)
    }
  }, [observerElement, shouldFocusQuestion])

  return (
    <ModalGeneric
      modalTitle={title}
      type='large'
      onCloseModal={onClose}
      containerRef={containerRef}
    >
      {showTabs && (
        <Tabs
          tabs={tabs}
          tabId='help-modal'
          selectedItem={selectedTab}
          onSelectTab={(tab) => setSelectedTab(tab)}
          data-cy='help-modal-tabs'
        />
      )}
      <Container>
        {selectedTab === 'PSIC' && questions.map((question) => (
          <Item 
            key={question.id} 
            ref={question.id === activeQuestion ? activeQuestionRef : null}
          >
            <Accordion
              expanded={question.id === activeQuestion}
              key={question.title}
              title={(
                <Typography
                  color='primary'
                  weight='bolder'
                  variant='content2'
                >
                  {question.title}
                </Typography>
              )}
            >
              <Typography
                variant='content2'
                inlineStyles={{
                  padding: '15px 0',
                  lineHeight: '19px',
                }}
              > 
                {question.text} 
              </Typography>
            </Accordion>  
          </Item>
        ))}
        {selectedTab === 'PSIQ' && (
          <PsiqTabWrapper data-cy='help-modal-psiq-tab'>
            <UnderConstruction />
            <Typography variant='content2'>Em breve</Typography>
          </PsiqTabWrapper>
        )}
      </Container>
    </ModalGeneric>
  )
}